import type {ReactElement} from 'react';
import {useContext} from 'react';
import type {Component, Editor} from 'grapesjs';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {getMainWrapper} from '@EmailMakerReact/lib/email-maker-component-query-library';
import {EmailMakerAddClearButton} from './components/add-clear-button/add-clear-button';
import {TileList} from './components/tile-list/tile-list';
import type {EmailMakerBottomBarProps} from './email-maker-bottom-bar.types';
import styles from './email-maker-bottom-bar.module.scss';

export function EmailMakerBottomBar({onTileSelect}: EmailMakerBottomBarProps): ReactElement {
  const {state, editor} = useContext(emailMakerContext);
  const selected = state.selectedComponent;

  return (
    <div className={styles.bar} role="region" aria-label={window.i18next.t('pmwjs_email_maker_bottom_bar_aria')}>
      <EmailMakerAddClearButton editor={editor} isComponentSelected={isNonWrapperSelected(selected, editor)} />
      <TileList selected={selected} onTileSelect={onTileSelect} />
    </div>
  );
}

/** The GrapesJS wrapper counts as the empty selection, so selecting it is not a real component selection. */
function isNonWrapperSelected(selected: Component | null, editor: Editor | null): boolean {
  if (!selected || !editor) {
    return false;
  }
  return getMainWrapper(editor)?.cid !== selected.cid;
}
